// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconArrowDownCircle = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M13 13.625V7h-2v6.625L8 11v2.5l4 3.5 4-3.5V11z" />,
    <path fillRule="evenodd" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0m-2 0a7 7 0 11-14 0 7 7 0 0114 0" />
  );
export default SvgIconArrowDownCircle;
